export default "__VITE_ASSET__Be6QzK3d__"